import T from "prop-types";
import React from "react";
import get from "lodash/get";
import omit from "lodash/omit";
import {
  FLAT_EXCHANGE,
  SECOND_EXCHANGE,
  THIRD_EXCHANGE
} from "MODULES/SalesOrders/constants";
import {
  EXCHANGE_GONE_OUTRIGHT,
  INTERNAL_OUTRIGHT
} from "MODULES/inventories/constants";

export const shouldSetQcPreapproval = (company, salesItem, cb = () => {}) => {
  const companyToInvMapping = {
    imperfect_trace: "imperfect_trace",
    no_ders_accepted: "der",
    no_pmas_accepted: "pma"
  };

  let shouldSet = false;
  Object.keys(companyToInvMapping).forEach(k => {
    if (company[k] && salesItem[companyToInvMapping[k]]) {
      cb();
      shouldSet = true;
    }
  });

  return shouldSet;
};

export const displayCustRmaWarning = ({ customer_rmas: customerRmas = [] }) =>
  customerRmas.filter(c => !c.cancelled).length > 0;

export const ExchangeIcon = ({ lineItem }) => {
  const exchangeTypes = [
    { key: "exchange_type", value: null, text: 1 },
    { key: FLAT_EXCHANGE, value: true, text: "F" },
    { key: "exchange_type", value: SECOND_EXCHANGE, text: 2 },
    { key: "exchange_type", value: THIRD_EXCHANGE, text: 3 },
    { key: EXCHANGE_GONE_OUTRIGHT, value: true, text: "O" },
    { key: INTERNAL_OUTRIGHT, value: true, text: "io" }
  ];

  const filteredVal = exchangeTypes.filter(
    f =>
      lineItem[f.key] === f.value &&
      (lineItem.exchange_sale ||
        lineItem.exchange_gone_outright ||
        lineItem[INTERNAL_OUTRIGHT] ||
        lineItem[FLAT_EXCHANGE])
  );

  if (filteredVal.length === 0) {
    return null;
  }

  return (
    <span className="fa-stack fa-1x">
      <i className="fa fa-lg fa-circle text-success" />
      <span className="fa fa-stack-1x exchange-circle-text">
        {filteredVal[filteredVal.length - 1].text}
      </span>
    </span>
  );
};

ExchangeIcon.propTypes = {
  lineItem: T.shape({ exchange_sale: T.bool, exchange_type: T.string })
};

export const getParentExchange = salesOrder =>
  salesOrder.get("line_items").find(i => i.get("parent_exchange_item"));

export const isLastExchange = lineItem =>
  (lineItem.exchange_sale &&
    !lineItem.second_exchange_item_id &&
    !lineItem.exchange_type) ||
  (lineItem.exchange_type === SECOND_EXCHANGE &&
    !lineItem.third_exchange_item_id) ||
  lineItem.exchange_type === THIRD_EXCHANGE;

export const salesOrderLastExchange = salesOrder =>
  salesOrder.line_items.find(l => isLastExchange(l));

export const shipToCountryIsNotUSA = (values, shippingToAddress) =>
  (values.ship_to_type &&
    values.ship_to_type !== "dropship" &&
    shippingToAddress &&
    shippingToAddress.country &&
    shippingToAddress.country !== "US") ||
  (values.ship_to_type === "dropship" &&
    get(values, "ship_to_shipping_address.country") &&
    get(values, "ship_to_shipping_address.country") !== "US");

export const transformSO = ({ final_destination_address, ...values }) => ({
  ...values,
  final_destination_address: omit(final_destination_address, ["company_name"]),
  final_destination_company_name: get(final_destination_address, "company_name")
});

export const mapSOToForm = ({
  final_destination_company_name,
  final_destination_address,
  ...salesOrder
}) => ({
  ...salesOrder,
  customer_po: salesOrder.customer_purchase_order_number,
  final_destination_address: Object.assign({}, final_destination_address, {
    company_name: final_destination_company_name
  })
});

export const mapROToForm = ({ ship_to_address, ...repairOrder }) => ({
  ...repairOrder,
  final_destination_address: Object.assign({}, ship_to_address, {
    company_name: repairOrder.company && repairOrder.company.name
  })
});

export const feeTableHeader = results => {
  if (
    results.some(
      item =>
        item.flat_exchange &&
        !item.internal_outright &&
        !item.exchange_gone_outright
    )
  ) {
    return "Flat Exchange Fee";
  } else if (results.some(item => item.exchange_sale)) {
    return "Exchange Fee";
  }
  return "Sales EA.";
};

export const getCost = lineItem => {
  // flat exchanges display additional est. repair cost to user in order to
  // display what the item will actually cost vs discounted price
  if (lineItem.flat_exchange)
    return Number(lineItem.cost) + Number(lineItem.repair_fee);

  if (lineItem.exchange_sale) return lineItem.cost;

  return lineItem.cumulative_cost_per_unit;
};

export const dropShip = type =>
  ["repair_station", "customer", "company", "dropship"].includes(type);

export const salesOrderMissingFields = (contact, company) =>
  (company && !company.billing_address) ||
  (contact &&
    company &&
    ([company.phone, contact.phone1].filter(f => f).length === 0 ||
      !contact.email ||
      !contact.name));



// WEBPACK FOOTER //
// ./app/modules/SalesOrders/helpers.jsx